import { useEffect, useRef, useState } from 'react';

export default function MotionUniverse() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="universe" ref={sectionRef} className="relative w-full min-h-screen flex items-center overflow-hidden py-16 sm:py-0">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/eefb23d094f3db12251749b873bf67fd.jpg)',
          filter: 'blur(8px)',
          opacity: 0.4
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80"></div>

      <div className="relative z-10 w-full flex flex-col md:flex-row items-center gap-10 md:gap-0 px-6 sm:px-10 md:px-0">
        {/* Left */}
        <div className={`w-full md:w-[45%] md:pl-[10%] flex flex-col justify-center transition-all duration-1200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-20'}`}>
          <h2 className="text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-tight mb-6 md:mb-12">
            <span className="block">Play</span>
            <span
              className="block bg-gradient-to-r from-[#c0c0c0] via-white to-[#c0c0c0] bg-clip-text text-transparent"
              style={{ textShadow: '0 0 40px rgba(255, 255, 255, 0.5)', animation: 'shimmerText 3s ease-in-out infinite' }}
            >
              Your Cards
            </span>
            <span className="block">Right</span>
          </h2>

          <div className="flex items-center gap-6 mt-2">
            <img
              src="https://readdy.ai/api/search-image?query=luxury%20limited%20edition%20custom%20playing%20card%20deck%20for%20streetwear%20brand%2C%20dark%20black%20background%20with%20chrome%20metallic%20silver%20finish%2C%20large%20ornate%20spade%20symbol%20with%20MB%20monogram%20logo%20integrated%2C%20ace%20of%20spades%20signature%20card%20featuring%20streetwear%20character%20with%20dreadlocks%20leaning%20against%20urban%20city%20building%20inside%20spade%2C%20electric%20blue%20glowing%20neon%20highlights%20and%20light%20flares%2C%20night%20sky%20with%20stars%20and%20smoke%20wisps%2C%20cinematic%20dramatic%20lighting%2C%20chrome%20metallic%20typography%20lettering%2C%20premium%20collectible%20card%20design%2C%20high%20detail%20ultra%20realistic%20product%20photography%2C%20gold%20and%20silver%20accents%2C%20urban%20night%20aesthetic%2C%20holographic%20foil%20effect&width=400&height=320&seq=motionboyzdeckcards2025v3&orientation=landscape"
              alt="Motion Boyz Luxury Custom Deck of Cards"
              className="deck-card-hover"
              style={{ width: '160px', height: '128px', objectFit: 'contain' }}
            />
          </div>
        </div>

        {/* Right */}
        <div className={`w-full md:w-[55%] flex items-center justify-center transition-all duration-1200 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'}`}>
          <img
            src="https://public.readdy.ai/ai/img_res/cf7ad331-824c-44a0-89e5-040ad000f9b9.png"
            alt="Motion Boyz Ace of Spades"
            style={{
              width: 'clamp(200px, 40vw, 420px)',
              height: 'clamp(200px, 40vw, 420px)',
              objectFit: 'contain',
              animation: 'zoomPulse 1.5s ease-in-out infinite',
              filter: 'drop-shadow(0 0 30px rgba(0, 212, 255, 0.5))',
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes shimmerText {
          0%, 100% { background-position: 0% 50%; filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.3)); }
          50% { background-position: 100% 50%; filter: drop-shadow(0 0 40px rgba(255, 255, 255, 0.6)); }
        }
        @keyframes zoomPulse {
          0%, 100% { transform: scale(1); filter: drop-shadow(0 0 30px rgba(0, 212, 255, 0.5)); }
          50% { transform: scale(1.35); filter: drop-shadow(0 0 60px rgba(0, 212, 255, 1)) drop-shadow(0 0 20px rgba(255, 255, 255, 0.8)); }
        }
        .deck-card-hover { transition: transform 0.3s ease, filter 0.3s ease; cursor: pointer; }
        .deck-card-hover:hover { transform: rotate(-8deg) scale(1.08); filter: drop-shadow(0 0 18px rgba(0, 212, 255, 0.8)) drop-shadow(0 0 6px rgba(255, 255, 255, 0.5)); }
      `}</style>
    </section>
  );
}
